// import { FormAppState } from "../../public_site";
import { List } from "immutable";
import * as moment from 'moment';
import { Checkbox, ChoiceGroup, DatePicker, DefaultButton, Dropdown, IStackStyles, ITextFieldStyleProps, ITextFieldStyles, Label, loadTheme, Stack, Text, TextField } from 'office-ui-fabric-react';
import * as React from "react";
import { Entity } from 'ts-lenses';
import { Action, any, AsyncState, IOWidget, mkWidget, Widget } from "widgets-for-react";
import * as Model from '../../generated_models';
// import { postFormSubmissionState, postFormSubmissionStateFinalized, postSchoolFormSubmissionState, postPRFormSubmissionState } from "./api";
import { status_error_renderer, status_sending_renderer, status_thank_you_renderer } from "./status_message_renderers";
import { AnswerWithNestedFields, DependenciesState, DependencyData, FieldData, FormData, FormState, GenericDependencyOutput, SectionData, StepData, TabData } from "./types";
import { are_all_dependencies_met, are_dependencies_met, calculateDependenciesOutput, DayPickerStrings, get2, is_dependency_met, ParseArrayFromString, ParseTableMap, set2, stepIsHidden, tuple, update_elem_in_list, update_field_AUX, zip } from "./utils";
// import { field_isNull, isValidUrl } from "../public_site/utils";
import i18next from "i18next"

export type FormAppState = {
  formState: FormState
  submittedData: AsyncState<FieldData[]>
  tabId?: number
  sectionId?: number


}
loadTheme({
  defaultFontStyle: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: 16,
    lineHeight: 24
  },
});
let remove_anders = (f: string) => {
  if (f.startsWith("Anders ")) return "Anders "
  return f
}
const debug = false


let get_answers_from_multiselect = (s: string): string[] => {

  let regexp = /\[(.*?)\]/g
  let extraIsReg = [...(s.match(regexp) || [])]
  return extraIsReg
}




export let show_optional = (input: boolean) => {
  return (input
    ? ""
    : ' form__label--optional'
  )
}

export type fieldWidthsInput = "Large" | 'Medium' | 'Small' | 'Extra small'
export type fieldWidthsOutput = '100' | '75' | '50' | '33'

export const fieldsWidth = (input: fieldWidthsInput): fieldWidthsOutput => {
  let output: fieldWidthsOutput = '100'

  if (input == 'Extra small') {
    output = '33'
  } else if (input == 'Small') {
    output = '50'
  } else if (input == 'Medium') {
    output = '75'
  }

  return output
}

const dropdownStyles = ({
  caretDownWrapper: {
    right: 'unset',
    left: '0px',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  caretDown: {
    color: "#253A79"
  },
  title: {
    padding: '12px 40px 12px 20px',
    height: 48,
    border: '1px solid #CCCCCC',
    fontSize: 16,
    outline: 'none !important',
    transition: 'all .3s'
  },
  dropdownItemsWrapper: {
    padding: '12px 40px 12px 20px',
  },
  dropdown: {
    border: 'none'
  },
  dropdownOptionText: {
    fontSize: 16
  },
  errorMessage: {
    fontSize: 16,
    color: '#E11022',
    paddingTop: 16
  }
});

const textFieldStyles = (props: ITextFieldStyleProps): Partial<ITextFieldStyles> => ({
  // ...(props.focused && {
  //   outline: 'none',
  //   fieldGroup: {
  //     outlineColor: 'none',
  //     // borderColor: '#CCC'
  //         border: '1px solid purple'
  //   },
  //   field: {
  //     ...(props.multiline ? {
  //     } : {
  //         // border: '1px solid #CCC'
  //         border: '1px solid yellow'
  //       })
  //   },
  // }),
  fieldGroup: {
    transition: 'all .3s',
    ...(props.multiline ? {
      border: 'none',
      minHeight: 192,
      padding: '12px 16px',
      outline: 'none',
      ...(props.focused && {
        borderColor: 'orange'
      })
    } : {
      height: 48,
      padding: '0',
    })
  },
  // field: {
  //   padding: '0',
  //   fontSize: 16,
  //   border: 'none',
  //   ...(props.multiline ? {
  //   } : {
  //     border: '1px solid #CCC',
  //       transition: 'all .3s'
  //     })
  // },
  // errorMessage: {
  //   fontSize: FontSizes.small,
  //   color: 'red',
  //   paddingTop: 10
  // },

  // subComponentStyles: {
  //   label: {
  //     fontSize: FontSizes.small,
  //     position: 'absolute',
  //     top: '50%',
  //     transform: 'translateY(-50%)'
  //   },
  // }
});

export let dependency_renderer = (dependency: DependencyData, formState: FormState) =>
  <Stack horizontal horizontalAlign={"start"} gap={5}>
    <Text variant={'medium'}><b>Title</b>: {dependency.dependency.title}</Text>
    <Text variant={'medium'}><b>Is met?</b> {`${is_dependency_met(dependency.dependency, formState)}`}</Text>
    <Text variant={'medium'}><b>Hide if violated?</b> {`${dependency.dependency.hideIfViolated}`}</Text>
    <Text variant={'medium'}><b>Kind</b>: {dependency.dependency.Kind}</Text>
    <Text variant={'medium'}><b>Dependent fields</b>: {dependency.dependent_fields.map(df => `${df.FieldId}`).join(',')}</Text>
  </Stack>

export const stackStyles: IStackStyles = { root: { width: `100%` } };
export const stackStyles1: IStackStyles = { root: { width: `100%` } };

export let isFieldStructureEqual = (field2: FieldData, field1: FieldData): boolean => {
  const different_answers = field1.maybe_answers.filter(ans1 => field2.maybe_answers.find(ans2 => ans2.Id == ans1.Id)?.value != ans1.value)
  const different_labels = field1.maybe_labels.filter(label1 => field2.maybe_labels.find(label2 => label2.Id == label1.Id)?.label != label1.label)
  if (different_answers.length > 0 || different_labels.length > 0) {
    return false
  }
  return true
}

export let reconstructField = (field: FieldData, field2: FieldData): FieldData => {
  let past_input = null
  let structural_equality_result: boolean = null

  structural_equality_result = isFieldStructureEqual(field, field2 as FieldData)
  past_input = field2.user_input || ""
  let new_answers = (field.maybe_answers as AnswerWithNestedFields[]).map(answer => {
    const answer2 = field2.maybe_answers.find(answer2 => answer2.Id == answer.Id)
    return { ...answer, nested_fields: zip(answer.nested_fields, answer2.nested_fields).map(([nf1, nf2]) => reconstructField(nf1, nf2)) }
  })

  if (structural_equality_result)
    return Entity<FieldData>(field).set("user_input", () => past_input || "")
      .set('maybe_answers', _ => new_answers || [])
      .commit()
  else {
    if (structural_equality_result == null)
      return field

    console.log('FOUND STRUCTURAL INEQUALITY')
    console.log(field)
    return field
  }
}

export let calculateFieldBasedOnPastInput = (field: FieldData, json: any): FieldData => {
  let rval = null

  try {
    (json.field_data ? json.field_data : json).forEach(entry => entry.fields.forEach((field2: FieldData) => {
      if (field.field.Id == field2.field.Id)
        rval = reconstructField(field, field2)
    }))

  } catch (error) {
    console.log(error)
    return field
  }

  if (rval != null)
    return rval
  return field
}

export let addPastSubmissionToUserInput = (formData: FormData): FormData => {

  if (!formData.latest_submission || !formData.latest_submission.json_content)
    return formData

  let json = JSON.parse(formData.latest_submission.json_content)

  let test: FormData = Entity<FormData>(formData).set('tabs', tabs => tabs.map(tab =>
    Entity<TabData>(tab).set('sections', sections => sections.map(section =>
      Entity<SectionData>(section).set('steps', steps => steps.map(step =>
        Entity<StepData>(step).set('fields', fields => fields.map(field => calculateFieldBasedOnPastInput(field, json))).commit()))
        .set('section', section => {
          if (!json.reviewed_sections)
            return section
          const reviewed_sections_ids = json.reviewed_sections as number[]
          if (reviewed_sections_ids.find(id => section.Id == id))
            return ({ ...section, reviewed: true })
          return section
        })
        .commit())).commit())).commit()

  return test
}

export let field_renderer = (field: FieldData, formState: FormState,
  update_field: (updated_field: FieldData, updatedDependencyState: DependenciesState) => void,
  state_outer: any,
  set_state: (_: any) => any,
  should_disable_last_check: boolean,
  checkboxRadioLabelFilter?: (title: string, label: Model.Label) => boolean) => {
  let isRequired = false
  if (formState.form_data.kind == 'loaded') {
    formState.form_data.value.tabs.forEach(tab => tab.sections.forEach(section => section.steps.forEach(s => s.dependencies.forEach(d => d.dependent_fields.forEach(f => { if (f.FieldId == field.field.Id) { isRequired = true } })))))
  }
  let dependencies_boolean_result_res = are_dependencies_met(field, formState)
  let default_selected_answer = field.maybe_answers.find(a => a.isDefaultSelected)
  let is_read_only = false
  // (formState.form_data.kind == 'loaded' && formState.form_data.value.latest_submission != null && formState.form_data.value.latest_submission.submission_finalized) || 
  // (formState.form_data.kind == "loaded" && formState.form_data.value.form.is_readonly != null && formState.form_data.value.form.is_readonly)

  const description = ""//JSON.parse(field.field.description)

  switch (field.field.Kind) {

    case "RadioOption":
      return (
        <div className={`radio-btn radio-btn--${field.field.ExtraClassName || "plain"} form__group form__group--${fieldsWidth(field.field.width_percentage)}`} key={`field-${field.field.Id}-${field.user_input}`}

          onBlur={_ => {
            if (field.user_input == undefined) {
              let res = update_field_AUX(field, "", formState)
              update_field(res.fieldData, res.dependencyState)
            }
          }}
        >
          {field.field.title && <h3 className="form__title text--l">{field.field.title} </h3>}
          {/* {description && description.blocks.length && description.blocks[0].text != "" &&
            <div className="form__description">
              {field.field.description && Components.RichText(false, "view", () => field.field.description, null)}
            </div>
          } */}


          <div className="radio-btn__wrap">
            <ChoiceGroup
              styles={{}}
              defaultSelectedKey={default_selected_answer != undefined ? `answer-${default_selected_answer.Id}` : ""}
              options={
                field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map(a => ({
                  key: `answer-${a.Id}`,
                  text: a.value,
                  disabled: is_read_only
                }))
              }
              selectedKey={((field) => {
                if (field.user_input == "" || field.user_input == undefined) return undefined
                let refined_input = field.maybe_answers.find(a => a.value.toLocaleLowerCase().replace(/ /g, "") == field.user_input.toLocaleLowerCase().replace(/ /g, ""))
                if (refined_input != undefined) return `answer-${refined_input.Id}`
                return `answer-${field.user_input}`
              })(field)}
              onChange={(_, selected_answer) => {
                if (field.field.Kind != 'RadioOption') return
                let res = update_field_AUX(field, selected_answer.text, formState)
                update_field(res.fieldData, res.dependencyState)
              }}
            />
            {field.user_input && field.maybe_answers.find((a) => field.user_input == a.value)?.nested_fields?.map((f, fi) => {
              let answer = field.maybe_answers.find(a => a.value == field.user_input)
              return field_renderer(
                f,
                formState,
                (updated_field, updatedDependencyState) => {
                  updated_field = {
                    ...field,
                    maybe_answers: List(field.maybe_answers).set(field.maybe_answers.indexOf(answer), {
                      ...answer,
                      nested_fields: List(answer.nested_fields).set(fi, updated_field).toArray()
                    }).toArray()
                  }
                  update_field(updated_field, updatedDependencyState)
                }, state_outer, set_state, should_disable_last_check
              )
            }
            )}
          </div>
          {field.user_input != undefined &&
            dependencies_boolean_result_res.kind == "no" && formState.should_render_deps
            ? <div className="alert">
              <p className="ms-TextField-errorMessage error-message">
                {dependencies_boolean_result_res.messages.filter(m => m != "" && m != undefined).join(" | ")}
              </p>
            </div>
            : null
          }
        </div>)
    case "RadioOptionTable":
      let prev_input = ParseArrayFromString(field.user_input)
      return (
        <div className={`form__group radio-table  form__group--${fieldsWidth(field.field.width_percentage)}`} key={`field-${field.field.Id}-${field.user_input}`}>
          {field.field.title && <h3 className="form__title text--l">{field.field.title} </h3>}
          {/* {description && description.blocks.length && description.blocks[0].text != "" &&
            <div className="form__description">
              {field.field.description && Components.RichText(false, "view", () => field.field.description, null)}
            </div>
          } */}
          <table className="table">
            <thead className="table__header">
              <tr className="table__row">
                {/* FITST TH NEEDS TO BE EMPTY */}
                <th></th>
                {/* FOR EVERY ANSWERS A TH */}
                {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map((answer) => (<th>{answer.value}</th>))}
              </tr>
            </thead>
            <tbody className="table__content">
              {field.maybe_labels.filter(checkboxRadioLabelFilter ? label => checkboxRadioLabelFilter(field.field.title, label) : _ => true).sort((a1, a2) => a1.Id - a2.Id).map((tableRow, index) =>
                <tr className="table__row">
                  <td className="table__column"><p>{tableRow.label}</p></td>
                  <td className="table__column table__column--flex" colSpan={field.maybe_answers.length}>
                    <ChoiceGroup
                      defaultSelectedKey={prev_input && prev_input[index] ? prev_input[index] : default_selected_answer != undefined ? `${tableRow.label} - ${default_selected_answer.Id}` : ""}
                      options={
                        field.maybe_answers.map(a => ({
                          key: `${tableRow.label} - ${a.value}`,
                          text: '',
                          disabled: is_read_only,
                        }))
                      }
                      onChange={(_, selected_answer) => {
                        let input = ParseArrayFromString(field.user_input)
                        if (input == undefined || input.length < field.maybe_labels.length) {
                          input = []
                          for (let i = 0; i < field.maybe_labels.length; i++) {
                            input.push("")
                          }
                        }
                        input[index] = selected_answer.key
                        let res = update_field_AUX(field, JSON.stringify(input), formState)
                        update_field(res.fieldData, res.dependencyState)
                      }}
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {
            dependencies_boolean_result_res.kind == "no" && formState.should_render_deps
              ? <div className="alert">
                <p className="ms-TextField-errorMessage error-message">
                  {dependencies_boolean_result_res.messages.filter(m => m != "" && m != undefined).join(" | ")}
                </p>
              </div>
              : null
          }
        </div>
      )

    case "TextList":
      return (
        <div className={`form__group text-multiline form__group--${fieldsWidth(field.field.width_percentage)}`} key={`field-${field.field.Id}`}>
          {field.field.title && <h3 className="form__title">{field.field.title} </h3>}
          {/* {description && description.blocks.length && description.blocks[0].text != "" &&
            <div className="form__description">
              {field.field.description && Components.RichText(false, "view", () => field.field.description, null)}
            </div>
          } */}
          <div>
            {field.user_input && ParseArrayFromString(field.user_input).map((ans, index) =>
              <Stack horizontal verticalAlign={"center"}>
                <TextField
                  borderless
                  autoAdjustHeight
                  multiline={field.field.Kind == "TextArea"}
                  rows={field.field.Kind == "TextArea" ? 2 : null}
                  className={`form__input form__input--xs ${field.user_input != undefined && dependencies_boolean_result_res.kind == "no" && formState.should_render_deps ? " form__input--error" : ""}`}
                  value={`${ans ? ans : ""}`}
                  disabled={is_read_only}
                  onChange={(e, text) => {
                    let newInput: string[] = JSON.parse(field.user_input)
                    newInput[index] = text
                    let res = update_field_AUX(field, JSON.stringify(newInput), formState)
                    update_field(res.fieldData, res.dependencyState)
                  }}
                />
                <DefaultButton
                  onClick={() => {
                    let input: string[] = ParseArrayFromString(field.user_input)
                    input.splice(index, 1)
                    field.user_input = JSON.stringify(input)
                    let res = update_field_AUX(field, field.user_input, formState)
                    update_field(res.fieldData, res.dependencyState)
                  }}
                  type="button"
                  disabled={is_read_only}
                  className="form__action form__action--remove"
                />
              </Stack>
            )}
            <DefaultButton
              onClick={() => {
                if (field.user_input == undefined) {
                  let input: string[] = [""]
                  field.user_input = JSON.stringify(input)
                }
                else {
                  let input = ParseArrayFromString(field.user_input)
                  input.push("")
                  field.user_input = JSON.stringify(input)
                }
                let res = update_field_AUX(field, field.user_input, formState)
                update_field(res.fieldData, res.dependencyState)
              }}
              text={i18next.t('form.fields.textlist_add')}
              type="button"
              disabled={is_read_only}
              className="button button--secondary form__action"
            />
          </div>
          {
            dependencies_boolean_result_res.kind == "no" && formState.should_render_deps
              ? <div className="alert">
                <p className="ms-TextField-errorMessage error-message">
                  {dependencies_boolean_result_res.messages.filter(m => m != "" && m != undefined).join(" | ")}
                </p>
              </div>
              : null
          }
        </div>
      )
    case "Dropdown":

      return (<>
        <div className={`form__group form__group--${fieldsWidth(field.field.width_percentage)}`}
          onBlur={_ => {
            if (field.user_input == undefined) {
              let res = update_field_AUX(field, "", formState)
              update_field(res.fieldData, res.dependencyState)
            }
          }}
        >
          {field.field.title && <h3 className="form__title text--l">{field.field.title} </h3>}
          {/* {description && description.blocks.length && description.blocks[0].text != "" &&
            <div className="form__description">
              {field.field.description && Components.RichText(false, "view", () => field.field.description, null)}
            </div>
          } */}
          <Dropdown
            className="dropdown"
            placeholder={i18next.t("form.make_a_choice")}
            selectedKey={field.user_input ? `answer-${remove_anders(field.user_input)}` : null}
            options={
              !field.field.useExternalSource ? field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map(a => ({
                key: `answer-${a.value}`,
                text: a.value,
                disabled: is_read_only,
                class: `dropdown__select`
              }))
                : !formState.context.external_options.has(field.field.sourceName) ? []
                  : formState.context.external_options.get(field.field.sourceName).map(a => ({
                    key: `answer-${a}`,
                    text: a,
                    class: `dropdown__select`
                  }))
            }
            onChange={(_, selected_answer: any) => {
              if (field.field.Kind != 'Dropdown') return
              let is_anders = selected_answer.text == "Anders "
              let res = update_field_AUX(field, is_anders ? "" : selected_answer.text, formState)
              update_field({ ...res.fieldData, user_input: is_anders ? "Anders " : res.fieldData.user_input }, res.dependencyState)
            }}
            // errorMessage={dependencies_boolean_result_res.kind == "no" ? dependencies_boolean_result_res.messages.join(" | ") : ""}
            // styles={{ dropdown: { width: '100%' }, root: { height: 48 } }}
            styles={dropdownStyles}
          />
          {field.user_input != undefined && dependencies_boolean_result_res.kind == "no" && !field.user_input.startsWith("Anders ") ?
            <p className="ms-TextField-errorMessage error-message">
              {dependencies_boolean_result_res.messages.join(" | ")}
            </p>
            : ''
          }
        </div>
        {
          field.user_input?.startsWith("Anders ") ?
            field_renderer({
              maybe_answers: [], maybe_labels: [], user_input: field.user_input.split("Anders ")[1] || "", field: {
                Id: field.field.Id, Kind: "Text", CreatedDate: moment.default(), description: "", itemOrderNumber: field.field.itemOrderNumber, label: "", optionalDefaultValue: "", placeholder: "", title: "", width_percentage: "Large"
              }
            }, formState, (f, u) => {
              update_field({ ...field, user_input: "Anders " + f.user_input }, u)
            }, state_outer, set_state, should_disable_last_check, checkboxRadioLabelFilter)
            : null
        }
      </>
      )

    case "Checkbox":
      return (
        <Stack className={`form__group checkbox form__group--${fieldsWidth(field.field.width_percentage)}`} key={`field-${field.field.Id}`}
          onBlur={_ => {
            if (field.user_input == undefined) {
              let res = update_field_AUX(field, "", formState)
              update_field(res.fieldData, res.dependencyState)
            }
          }}
        >
          {/* {field.field.description && Components.RichText(false, "view", () => field.field.description, null)} */}
          <div className="checkboxes__wrap">
            <Checkbox
              label={field.field.title}
              defaultChecked={field.field.optionalDefaultValue.toLowerCase() == 'true'}
              disabled={is_read_only}
              checked={field.user_input == 'true'}
              onChange={(_, checked) => {
                let res = update_field_AUX(field, `${checked ? true : ""}`.toLowerCase(), formState)
                update_field(res.fieldData, res.dependencyState)
              }}
            />
            {/* <svg className="checkbox__checkmark" height="10" viewBox="0 0 16 14" width="11" xmlns="http://www.w3.org/2000/svg">
              <path d="m380 1834.96686 4.888931 6.03314 9.111069-12" fill="none" stroke="#FFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" transform="translate(-379 -1828)" />
            </svg> */}
            {field.user_input != undefined &&
              dependencies_boolean_result_res.kind == "no" && formState.should_render_deps
              ? <div className="alert">
                <p className="ms-TextField-errorMessage error-message">
                  {dependencies_boolean_result_res.messages.filter(m => m != "" && m != undefined).join(" | ")}
                </p>
              </div>
              : null
            }
          </div>
        </Stack>
      )

    case "CheckboxMultiSelect":
      return (
        <>
          <div className={`form__group checkboxes checkboxes--${field.field.ExtraClassName || "plain"} form__group--${fieldsWidth(field.field.width_percentage)}`} key={`field-${field.field.Id}-${field.user_input}`}
            onBlur={_ => {
              if (field.user_input == undefined) {
                let res = update_field_AUX(field, "", formState)
                update_field(res.fieldData, res.dependencyState)
              }
            }}
          >
            {field.field.title && <h3 className="form__title">{field.field.title} </h3>}
            {/* {description && description.blocks.length && description.blocks[0].text != "" &&
              <div className="form__description">
                {field.field.description && Components.RichText(false, "view", () => field.field.description, null)}
              </div>
            } */}

            <div className="checkboxes__wrap">
              {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map(
                (a, ai) => <>
                  <Checkbox
                    label={remove_anders(a.value)}
                    defaultChecked={a.isDefaultSelected}
                    disabled={is_read_only}
                    checked={((field) => {
                      {
                        let parts = get_answers_from_multiselect(field.user_input || "")
                        let res = parts.find(s => a.value == "Anders " ? s.startsWith("[Anders ") : s.includes(a.value))
                        return res != undefined
                      }
                    })(field)}
                    onChange={(_, selected_answer) => {
                      if (field.field.Kind != 'CheckboxMultiSelect') return

                      if (a.shouldSelectAllAnswers == true) {

                        let answersCount = field.maybe_answers.length
                        if (!field.user_input) { // if it's undefined first run (prevents errors)
                          field.user_input = ("[" + a.value + "]")
                        }

                        let selectedFields = field.maybe_answers.filter((_a, _ai) => field.user_input.includes("[" + _a.value + "]"))
                        if (selectedFields.length == 1 || selectedFields.length < answersCount - 1) {
                          let res = update_field_AUX(
                            field,
                            field.maybe_answers
                              .filter((_a, _ai) => _a.shouldSelectAllAnswers != true)
                              .map((_a, _ai) => `[${_a.value}]`)
                              .join(""),
                            formState)
                          update_field(res.fieldData, res.dependencyState)
                        } else {
                          // deselect all
                          let res = update_field_AUX(
                            field,
                            "",
                            formState)
                          update_field(res.fieldData, res.dependencyState)
                        }
                      }
                      else {
                        let res = update_field_AUX(
                          field,
                          selected_answer
                            ? `${field.user_input ? field.user_input : ""}[${a.value}]`
                            : field.user_input.replace("[" + a.value + "]", ""),
                          formState)
                        update_field(res.fieldData, res.dependencyState)
                      }


                    }}
                  />
                  {field.user_input?.includes(`[${a.value}]`)
                    ? a.nested_fields.map((f, fi) =>
                      field_renderer(
                        f,
                        formState,
                        (field1) => {
                          let res = update_field_AUX(field1, field1.user_input, formState)
                          let updated_field: FieldData = {
                            ...field,
                            maybe_answers: List(field.maybe_answers).set(ai, {
                              ...a,
                              nested_fields: List(a.nested_fields).set(fi, res.fieldData).toArray()
                            }).toArray()
                          }
                          update_field(updated_field, res.dependencyState)
                        }, state_outer, set_state, should_disable_last_check
                      )
                    ) : null}
                </>
              )}
            </div>
            {field.user_input != undefined &&
              dependencies_boolean_result_res.kind == "no" && formState.should_render_deps
              && !field.user_input.includes("[Anders ")
              ? <div className="alert">
                <p className="ms-TextField-errorMessage error-message">
                  {dependencies_boolean_result_res.messages.filter(m => m != "" && m != undefined).join(" | ")}
                </p>
              </div>
              : null
            }
          </div>
          {((() => {
            if (field.user_input == undefined || field.user_input == "") return null
            let parts = get_answers_from_multiselect(field.user_input)
            let maybe_anders = parts.find(p => p.startsWith("[Anders "))
            let maybe_anders_clean = maybe_anders ? maybe_anders.substr(1, maybe_anders.length - 2) : ""

            return maybe_anders ?
              <>
                <strong> <p> {i18next.t("form.multiple_answer_field_sample_text")}</p></strong>
                {field_renderer({
                  maybe_answers: [], maybe_labels: [], user_input: maybe_anders_clean.split("Anders ")[1] || "", field: {
                    Id: field.field.Id, Kind: "Text", CreatedDate: moment.default(), description: "", itemOrderNumber: field.field.itemOrderNumber, label: "", optionalDefaultValue: "", placeholder: "", title: "", width_percentage: "Large"
                  }
                }, formState, (f, u) => {
                  update_field({ ...field, user_input: parts.map(p => p.startsWith("[Anders ") ? "[Anders " + f.user_input + "]" : p).join() }, u)
                }, state_outer, set_state, should_disable_last_check, checkboxRadioLabelFilter)}
              </>
              : null
          })())
          }
        </>
      )

    case "SimpleDate":
      let field1 = field.field
      return (
        <Stack
          onBlur={_ => {
            if (field.user_input == undefined) {
              let res = update_field_AUX(field, "", formState)
              update_field(res.fieldData, res.dependencyState)
            }
          }}
          className={`form__group  form__group--${fieldsWidth(field.field.width_percentage)} 
        checkboxex${field.user_input != undefined && dependencies_boolean_result_res.kind == 'no' ? ' form__group--error' : ''
            } text-input${field.user_input != undefined && dependencies_boolean_result_res.kind == 'no' ? ' form__group--error' : ''
            }`}
        >
          {field.field.title && <h3 className="form__title">{field.field.title} </h3>}
          {(() => {
            const onFormatDate = (date?: Date): string => {
              return !date ? '' : date.getDate() + '/' + (date.getMonth() + 1) + '/' + (date.getFullYear() % 100);
            };

            const onParseDateFromString = (newValue: string): Date => {
              const previousValue = moment.default(field.user_input)?.toDate() || new Date();
              const newValueParts = (newValue || '').trim().split('/');
              const day =
                newValueParts.length > 0 ? Math.max(1, Math.min(31, parseInt(newValueParts[0], 10))) : previousValue.getDate();
              const month =
                newValueParts.length > 1
                  ? Math.max(1, Math.min(12, parseInt(newValueParts[1], 10))) - 1
                  : previousValue.getMonth();
              let year = newValueParts.length > 2 ? parseInt(newValueParts[2], 10) : previousValue.getFullYear();
              if (year < 100) {
                year += previousValue.getFullYear() - (previousValue.getFullYear() % 100);
              }

              return new Date(year, month, day);
            }

            return <DatePicker
              textField={{ height: 60, }}
              firstDayOfWeek={1}
              strings={DayPickerStrings}
              allowTextInput
              placeholder={field1.placeholder != undefined ? field1.placeholder : ''}
              ariaLabel="Select a date"
              value={field.user_input === '' || field.user_input === undefined ? undefined : moment.default(field.user_input).toDate()}
              formatDate={onFormatDate}
              parseDateFromString={onParseDateFromString}
              minDate={
                (field1.StartDate as any) == ''
                  ? null
                  : typeof field1.StartDate == 'string'
                    ? moment.default(field1.StartDate).toDate()
                    : field1.StartDate.toDate()
              }
              // isMonthPickerVisible={false}
              onSelectDate={(new_date) => {
                if (new_date == null || new_date == undefined) return
                let res = update_field_AUX(field, moment.default(new_date, 'DD-MM-YYYY').format(), formState)
                update_field(res.fieldData, res.dependencyState)
              }}
            />
          })()}
          {field.user_input != undefined && dependencies_boolean_result_res.kind == 'no' ? (
            <div className="alert">
              <p className="ms-TextField-errorMessage error-message">{dependencies_boolean_result_res.messages.join(' | ')}</p>
            </div>
          ) : null}
        </Stack>
      )
    case "CheckboxGroup":
      let checkboxInput: { id: number, label: string, values: string[] }[] = field.user_input ? JSON.parse(field.user_input) : []
      return (
        <div className={`form__group checkboxes-table form__group--${fieldsWidth(field.field.width_percentage)}`} key={`field-${field.field.Id}`}>
          {field.field.title && <h3 className="form__title">{field.field.title}</h3>}
          {/* {description && description.blocks.length && description.blocks[0].text != "" &&
            <div className="form__description">
              {field.field.description && Components.RichText(false, "view", () => field.field.description, null)}
            </div>
          } */}
          <table className="form__table table">
            <thead className="table__header">
              <tr className="table__row">
                {/* FITST TH NEEDS TO BE EMPTY */}
                <th></th>
                {/* FOR EVERY ANSWERS A TH */}
                {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map((answer) => (<th>{answer.value}</th>))}
              </tr>
            </thead>
            <tbody className="table__content">
              {field.maybe_labels.filter(checkboxRadioLabelFilter ? label => checkboxRadioLabelFilter(field.field.title, label) : _ => true).sort((l1, l2) => l1.Id - l2.Id).map((label) => (
                <tr className="table__row">
                  <td className="table__column">
                    <p>{i18next.t(label.label)}</p>
                  </td>
                  {field.maybe_answers.map((a) => (
                    <td className="table__column">
                      <Checkbox
                        checked={checkboxInput.findIndex((x) => x.id === label.Id && x.values.includes(a.value)) !== -1}
                        defaultChecked={a.isDefaultSelected}
                        disabled={is_read_only}
                        onChange={(_, selected_answer) => {
                          if (field.field.Kind != "CheckboxGroup") return;
                          let checkboxInput: List<{ id: number, label: string, values: string[] }> =
                            field.user_input && field.user_input != "" ? List(JSON.parse(field.user_input)) : List();
                          let res = null;
                          if (checkboxInput.find(c => c.id == label.Id))
                            checkboxInput = checkboxInput.map<{ id: number, label: string, values: string[] }>(c => {
                              if (c.id != label.Id) return c;
                              if (selected_answer)
                                c.values.push(a.value)
                              else
                                c.values = c.values.filter(v => v != a.value)
                              return c;
                            }).filter(c => c.values?.length > 0).toList()
                          else
                            checkboxInput = checkboxInput.push({ id: label.Id, label: label.label, values: [a.value] })

                          res = update_field_AUX(field, JSON.stringify(checkboxInput.toArray()), formState);


                          update_field(res.fieldData, res.dependencyState);
                        }}
                      />
                      <svg className="checkbox__checkmark" height="10" viewBox="0 0 16 14" width="11" xmlns="http://www.w3.org/2000/svg">
                        <path d="m380 1834.96686 4.888931 6.03314 9.111069-12" fill="none" stroke="#FFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" transform="translate(-379 -1828)" />
                      </svg>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          {
            dependencies_boolean_result_res.kind == "no" && formState.should_render_deps
              ? <div className="alert">
                <p className="ms-TextField-errorMessage error-message">
                  {dependencies_boolean_result_res.messages.filter(m => m != "" && m != undefined).join(" | ")}
                </p>
              </div>
              : null
          }
        </div>
      );
    case 'ReadonlyText':
      // let start_with_basis = field.field.title.toLocaleLowerCase().trim().split(" ").join("").startsWith("basis=")
      // if (start_with_basis) {
      //   let text_after_basis = field.field.title.split(/=(.+)/)[1].trim()

      //   return <Stack className={"form__group text-field read-only form__group--banner"} key={`field-${field.field.Id}`}>
      //     <h2>
      //       <span className="form__highlight">Basis = </span>
      //       {field.field.title && <>{text_after_basis}</>}
      //     </h2>
      //     {/* {description && description.blocks.length && description.blocks[0].text != "" &&
      //       <div className="form__description">
      //         {field.field.description && Components.RichText(false, "view", () => field.field.description, null)}
      //       </div>
      //     } */}
      //   </Stack>
      // }
      // else {
      return <Stack className={`form__group text-field read-only form__group--${fieldsWidth(field.field.width_percentage)}`} key={`field-${field.field.Id}`}>
        {field.field.title && <h3 className="form__title text--l">{field.field.title} </h3>}

        <div className="form__text">
          {field.user_input}
        </div>
        {/* {description && description.blocks.length && description.blocks[0].text != "" &&
            <div className="form__description">
              {field.field.description && Components.RichText(false, "view", () => field.field.description, null)}
            </div>
          } */}
        {/* {description && description.blocks.length && description.blocks[0].text != "" &&
            <div className="form__description">
              {field.field.description && Components.RichText(false, "view", () => field.field.description, null)}
            </div>
          } */}
      </Stack>
    case 'TextHTML':
      return <Stack className={`form__group text-field read-only form__group--${fieldsWidth(field.field.width_percentage)}`} key={`field-${field.field.Id}`}>
        {field.field.title && <h3 className="form__title text--l">{field.field.title} </h3>}

        <div className="form__text" dangerouslySetInnerHTML={{ __html: field.user_input }} />
      </Stack>
    case 'TextInputTable':
      let past_input = ParseTableMap(field.user_input)
      return (
        <div className={`form__group form__group--${fieldsWidth(field.field.width_percentage)}`} key={`field-${field.field.Id}`}> {/* we need a new classname for this */}
          {field.field.title && <h3 className="form__title text--l">{field.field.title} </h3>}
          {/* {description && description.blocks.length && description.blocks[0].text != "" &&
            <div className="form__description">
              {field.field.description && Components.RichText(false, "view", () => field.field.description, null)}
            </div>
          } */}

          <table className="table">
            <thead className="table__header">
              <tr className="table__row">
                {/* FITST TH NEEDS TO BE EMPTY */}
                <th></th>
                {/* FOR EVERY ANSWERS A TH */}
                {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map((answer) => (<th>{answer.value}</th>))}
              </tr>
            </thead>
            <tbody className="table__content">
              {field.maybe_labels.sort((a1, a2) => a1.Id - a2.Id).map((tableRow, index) =>
                <tr className="table__row">
                  <td className="table__column"><p>{tableRow.label}</p></td>
                  {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map(answer => <td className="table__column">
                    <TextField
                      borderless
                      autoAdjustHeight
                      multiline={field.field.Kind == "TextArea"}
                      rows={field.field.Kind == "TextArea" ? 2 : null}
                      className={`form__input ${field.user_input != undefined && dependencies_boolean_result_res.kind == "no" && formState.should_render_deps ? " form__input--error" : ""}`}
                      value={get2(past_input, tableRow.label, answer.value) ? get2(past_input, tableRow.label, answer.value) : ""}
                      disabled={is_read_only}
                      onChange={(e, text) => {
                        let new_input = set2(past_input, tableRow.label, answer.value, text)
                        let res = update_field_AUX(field, JSON.stringify(new_input), formState)
                        update_field(res.fieldData, res.dependencyState)
                      }}
                    />
                  </td>)}
                </tr>
              )}
            </tbody>
          </table>
          {
            dependencies_boolean_result_res.kind == "no" && formState.should_render_deps
              ? <div className="alert">
                <p className="ms-TextField-errorMessage error-message">
                  {dependencies_boolean_result_res.messages.filter(m => m != "" && m != undefined).join(" | ")}
                </p>
              </div>
              : null
          }
        </div>
      )
    case 'Attachement':
      return (
        <Stack className={`form__group text-multiline form__group--attachement form__group--${fieldsWidth(field.field.width_percentage)}`}>
          <Label className={`h3 form__label${show_optional(isRequired)} text--xs`}>
            {i18next.t(field.field.title)}
            {isRequired ? '*' : ''}
          </Label>
          {field.user_input && field.user_input !== 'None' && field.user_input.length > 0 ? <img src={field.user_input} /> : <></>}
          <input
            className={`form__input form__input--image ${field.user_input != undefined && dependencies_boolean_result_res.kind == "no" && formState.should_render_deps ? " form__input--error" : ""}`}
            type="file"
            accept="image/*"
            onChange={(e: any) => {
              let files: FileList = (e.target as any).files;
              let file_reader = new FileReader()

              file_reader.onload = ((e) => {
                let new_value = file_reader.result
                let res = update_field_AUX(field, new_value as string, formState)
                update_field(res.fieldData, res.dependencyState)
              });

              file_reader.readAsDataURL(files[0]);
            }}

          />
          {field.user_input && field.user_input.length > 0 && (<DefaultButton
            onClick={() => {
              let res = update_field_AUX(field, 'None', formState)
              update_field(res.fieldData, res.dependencyState)
            }}
            type="button"
            disabled={is_read_only}
            className="form__action form__action--remove"
          />)}
          {
            dependencies_boolean_result_res.kind == "no"
              ? <div className="alert">
                <p className="ms-TextField-errorMessage error-message">
                  {dependencies_boolean_result_res.messages.filter(m => m != "" && m != undefined).join(" | ")}
                </p>
              </div>
              : null
          }

        </Stack>
      )
    case "JSXElement":
      return field.field.JSX(state_outer, set_state)
    case 'AttachementList':
      const customInput = //field.user_input
        // ? ParseArrayFromString(field.user_input).filter(ans => ans.includes("-Gallery-1260x740.jpeg") || !isValidUrl(ans))
        // : 
        null

      return (
        <div className="form__group text-multiline form__group--attachements" key={`field-${field.field.Id}`}
          onBlur={_ => {
            if (field.user_input == undefined) {
              let res = update_field_AUX(field, "", formState)
              update_field(res.fieldData, res.dependencyState)
            }
          }}
        >
          {field.field.title && <h3 className="form__title">{field.field.title} </h3>}
          {/* {description && description.blocks.length && description.blocks[0].text != "" &&
            <div className="form__description">
              {field.field.description && Components.RichText(false, "view", () => field.field.description, null)}
            </div>
          } */}
          <div>
            {customInput && customInput.map((ans, index) =>
              <Stack horizontal verticalAlign={"center"} className="form__image-attachement">
                {ans && ans.length > 0 ? <img src={ans} /> : <></>}
                <input className={`form__input ${ans != undefined && dependencies_boolean_result_res.kind == "no" && formState.should_render_deps ? " form__input--error" : ""}`}
                  type="file"
                  accept="image/*"
                  onChange={(e: any) => {
                    let files: FileList = (e.target as any).files;
                    let file_reader = new FileReader()

                    file_reader.onload = ((e) => {
                      let new_value = file_reader.result as string
                      let newInput: string[] = JSON.parse(field.user_input)
                      const indexOfEmptySlot: number = newInput.findIndex(image => image === "")
                      newInput[indexOfEmptySlot] = new_value
                      let res = update_field_AUX(field, JSON.stringify(newInput), formState)
                      update_field(res.fieldData, res.dependencyState)
                    });

                    file_reader.readAsDataURL(files[0]);
                  }}

                />
                <DefaultButton
                  onClick={() => {
                    let input: string[] = ParseArrayFromString(field.user_input)

                    // if(isValidUrl(customInput[index]))
                    // {
                    //   const removed_image : string[] = customInput.splice(index, 1)[0].match(/https?:\/\/.*\/(\d*)-(\d*)/)
                    //   const image_cluster_id : string = removed_image[1] + "-" + removed_image[2]
                    //   input = input.filter(image => !image.includes(image_cluster_id))
                    // }else
                    // {
                    input = input.filter(image => image != customInput[index] && image)
                    customInput.splice(index, 1)
                    // }
                    field.user_input = JSON.stringify(input)
                    let res = update_field_AUX(field, field.user_input, formState)
                    update_field(res.fieldData, res.dependencyState)
                  }}
                  type="button"
                  disabled={is_read_only}
                  className="form__action form__action--remove"
                />
              </Stack>
            )}
            <DefaultButton
              onClick={() => {
                if (field.user_input == undefined) {
                  let input: string[] = [""]
                  field.user_input = JSON.stringify(input)
                }
                else {
                  let input = ParseArrayFromString(field.user_input)
                  input.push("")
                  field.user_input = JSON.stringify(input)
                }

                let res = update_field_AUX(field, field.user_input, formState)
                update_field(res.fieldData, res.dependencyState)
              }}
              text={i18next.t('form.fields.textlist_add')}
              type="button"
              disabled={is_read_only}
              className="button button--secondary form__action"
            />
          </div>
          {field.user_input != undefined &&
            dependencies_boolean_result_res.kind == "no" && formState.should_render_deps
            ? <div className="alert">
              <p className="ms-TextField-errorMessage error-message">
                {dependencies_boolean_result_res.messages.filter(m => m != "" && m != undefined).join(" | ")}
              </p>
            </div>
            : null
          }
        </div>
      )
    default:
      return (
        <Stack className={`form__group text-field form__group--${fieldsWidth(field.field.width_percentage)}`} key={`field-${field.field.Id}`}
          onBlur={_ => {
            if (field.user_input == undefined) {
              let res = update_field_AUX(field, "", formState)
              update_field(res.fieldData, res.dependencyState)
            }
          }}
        >
          {field.field.title && <h3 className="form__title text--l">{field.field.title} </h3>}

          {/* {description && description.blocks.length && description.blocks[0].text != "" &&
            <div className="form__description">
              {
              field.field.description// && Components.RichText(false, "view", () => field.field.description, null)
              }
            </div>
          } */}
          <div
            id={"input " + field.field.Id}
            className={`form__input form__input-texteditor form__input--counter ${is_read_only ? 'form__input--readonly' : ''} ${field.user_input != undefined && dependencies_boolean_result_res.kind == "no" && formState.should_render_deps ? " form__input--error" : ""}`}>

            {/* <Editor
              readOnly={is_read_only}
              toolbarHidden={is_read_only || field.field.Kind != "TextArea"}
              //toolbarOnFocus={field.field.Kind != "TextArea"}
              toolbar={
                {
                  // options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history']                
                  options: ['list']
                }
              }
              defaultEditorState={(() => {
                let text = field.user_input && typeof(field.user_input) == "string" ? field.user_input : ""
                try {
                  let _contentState = convertFromRaw(JSON.parse(text))
                  let state = Draft.EditorState.createWithContent(_contentState)
                  return state
                }
                catch{
                  return Draft.EditorState.createWithContent(Draft.ContentState.createFromText(text))
                }
              })()}
              wrapperClassName="wrapper-class"
              editorClassName="editor-class"
              toolbarClassName="toolbar-class"
              onEditorStateChange={v => {
                let res = update_field_AUX(field, JSON.stringify(convertToRaw(v.getCurrentContent())), formState)
                update_field(res.fieldData, res.dependencyState)
              }}
            /> */}
            <TextField //placeholder={field.placeholder != undefined ? field.placeholder : ""}
              // borderless
              autoAdjustHeight
              value={`${field.user_input ? field.user_input : ""}`}
              disabled={is_read_only}
              onChange={(e, text) => {
                let res = update_field_AUX(field, text, formState)
                update_field(res.fieldData, res.dependencyState)
              }}
              style={{
                outline: 'none',
                borderColor: "transparent",
                borderRadius: '4px',
                fontSize: 16,
                padding: '12px 16px'
              }}
              styles={textFieldStyles}
            />
          </div>
          <div className="input__footer">
            {/* <div className="count" id={"count " + field.field.Id}>
              <span className="count__label">Aantal karakters:</span>
              <span className="count__value">{`${get_text_from_draftjs(field.user_input ? field.user_input.toString() : "").replace(/ /g, '').length}${(() => {
                const max_length_dep = get_associated_dependencies(field, formState).find(dep => dep.Kind == 'FieldLengthMax')
                return max_length_dep ? `/${(max_length_dep as Model.FieldLengthMax).value}` : ''
              })()}`}</span>
            </div> */}
            {
              field.user_input != undefined && dependencies_boolean_result_res.kind == "no" && formState.should_render_deps
                ? <div className="alert">
                  <p className="ms-TextField-errorMessage error-message">
                    {(dependencies_boolean_result_res as any).messages.filter(m => m != "" && m != undefined).join(" | ")}
                  </p>
                </div>
                : null
            }
          </div>

        </Stack>
      )
  }
}

export let step_renderer = (step: StepData, formState: FormState, update_step: (updated_step: StepData, updatedDependencyState: DependenciesState) => void,
  state_outer: any, set_state: (_: any) => any,
  should_disable_last_check: boolean,
  checkboxRadioLabelFilter?: (title: string, label: Model.Label) => boolean) => {
  let shouldHide: boolean = false
  step.dependencies.forEach(dep => {
    if (dep.dependency.hideIfViolated && !is_dependency_met(dep.dependency, formState)) {
      shouldHide = true
    }
  })
  if (shouldHide) return (<></>)
  else return (
    <>
      {formState.form_data.kind == "loaded"}
      <>
        {step.fields.sort((a, b) => a.field.itemOrderNumber - b.field.itemOrderNumber).map((field, i) => field_renderer(field,
          formState,
          (field1, updated_dependencies) =>
            update_step(
              { ...step, fields: update_elem_in_list(step.fields, i, field1) },
              updated_dependencies
            ), state_outer, set_state, should_disable_last_check,
          checkboxRadioLabelFilter))}
      </>
      {
        debug
          ? <Stack>
            <Text variant={'large'}> Dependencies: </Text>
            <Stack gap={10}>
              {step.dependencies.map(dependency => dependency_renderer(dependency, formState))}
            </Stack>
          </Stack>
          : null
      }
    </>)
}

export let form_renderer = (data_f: FormData, formAppState: FormAppState,
  update_form_submission_logic: (updated_form_submission_logic: AsyncState<string>) => void,
  update_form: (updated_form: FormData, updatedDependencyState: DependenciesState) => void,
  state_outer: any,
  set_state: (_: any) => any,
  should_disable_last_check: boolean,
  tabId?: number, //specific tab to render
  sectionId?: number,
  checkboxRadioLabelFilter?: (title: string, label: Model.Label) => boolean
): Widget<Action<FormAppState>> => { //specific section to render
  const formState = formAppState.formState
  let dependencies_boolean_result = are_all_dependencies_met(formState)
  let section: SectionData = tabId && tabId != -1 && tabId != -2
    ? sectionId
      ? data_f.tabs.filter(tab => tab.tab.Id == tabId)[0].sections.filter(section => section.section.Id == sectionId)[0]
      : data_f.tabs.filter(tab => tab.tab.Id == tabId)[0].sections[0]
    : undefined
  // if (appState.currently_rendering == 'schoolprofiel-form')

  return mkWidget({
    run: setState => <Stack styles={stackStyles} className="form">
      {formState.form_submission_logic.kind == 'loading' && status_sending_renderer()}
      {formState.form_submission_logic.kind == 'connection-error' && formState.form_submission_logic.retryCount >= 10 && status_error_renderer()}
      {formState.form_submission_logic.kind == 'loaded' && formState.form_submission_logic.value == 'finalized' && formState.form_data.kind == 'loaded'
        ? status_thank_you_renderer(formState.form_data.value.thank_you.content)
        : <>
          <Stack className="form__inner">
            <Stack className="form"  /* gap={20} */ horizontal wrap>
              {section.section.title && <h2 className="form__title">{section.section.title}</h2>}
              {section && section.steps.filter(step => !stepIsHidden(step, formState)).length == 0 && <Stack className="form__group text-field read-only" key="random-key">
                {i18next.t("form.no_actions_required_text")}
              </Stack>
              }
              {formState.form_data.kind == "loaded" && tabId == null && setTabIdSectionId(formState.form_data.value).run(setState)}
              {tabId && tabId == -1
                ? (<div>
                  {/* <h1>Show payment widget here</h1> */}
                  {/* <h1>Show succes widget here</h1> */}
                  <h2 className="block__title">{i18next.t("Beslismatrix.Success_Text")}</h2><br />
                  {/* {i18next.t("form.submit_tab.body")}<br />
                  <br />
                  {i18next.t("form.submit_tab.download_pdf_text")}<br />
                  <br />
                  <br />
                  <br />
                  Planning<br />
                  {i18next.t("form.submit_tab.planning1")}<br />
                  {i18next.t("form.submit_tab.planning2")}<br />
                  <div className="form__nav-button">
                    <DefaultButton //code for finalising submition
                      onClick={() => 
                          console.log("update_form_submission_logic")
                      //  update_form_submission_logic(postFormSubmissionStateFinalized(data_f.form.Id, formState, school_id))
                      
                      }
                      disabled={
                        true
                        // calculateFormCompletionPercentage(formState.form_data.kind == "loaded" && formState.form_data.value) != 100 || 
                        // (formState.form_data.kind == "loaded" && formState.form_data.value.latest_submission.submission_finalized === true) 
                        // || 
                        // (formState.form_data.kind == "loaded" && formState.form_data.value.form.is_readonly === true)
                      }
                      text={i18next.t("form.submit_button_text")}
                      type="button"
                      className="form__button button button--primary" />
                  </div>
                  {!dependencies_boolean_result ? i18next.t("form.message_error_send_page") : null} <br />
                  {(() => {
                    let items: INavLinkGroup[] = !dependencies_boolean_result && formState.form_data.kind == 'loaded' ?
                      [{

                        links: formState.form_data.value.tabs.filter(tab => calculateDependenciesOutput(tab, formState).kind == 'no' || calculateDependenciesOutput(tab, formState).kind == 'not_reviewed').map(tab => ({
                          name: tab.tab.title,
                          expandAriaLabel: 'Expand ' + tab.tab.title,
                          collapseAriaLabel: 'Collapse ' + tab.tab.title,
                          url: "",
                          iconClassName: "tab_icon",
                          links: tab.sections.filter(section => calculateDependenciesOutput(section, formState).kind == 'no' || calculateDependenciesOutput(tab, formState).kind == 'not_reviewed').map(section => ({
                            name: section.section.title,
                            expandAriaLabel: 'Expand ' + section.section.title,
                            collapseAriaLabel: 'Collapse ' + section.section.title,
                            url: "",
                            iconClassName: "section_icon",
                            links: section.steps.filter(step => calculateDependenciesOutput(step, formState).kind == 'no' || calculateDependenciesOutput(tab, formState).kind == 'not_reviewed').flatMap(step => step.fields).filter(field => are_dependencies_met(field, formState).kind == 'no').map(field => ({
                              name: field.field.title,
                              url: ""
                            }))
                          })
                          )
                        }))
                      }]
                      : []

                    return <div className="alert">
                      <div className="form__nav form__nav--dropdown">
                        <Nav className="nav__list" ariaLabel={i18next.t("form.unmet_dependencies_text")} groups={items} />
                      </div>
                    </div>
                  })()} */}

                </div>)
                : (section) ? <>
                  {section.steps.sort((a, b) => a.step.orderNumber - b.step.orderNumber).map(step => <>
                    {step_renderer(
                      step,
                      formState,
                      (step1, updated_dependencies) =>
                        update_form(
                          Entity<FormData>(data_f).set('tabs', tabs => tabs.map(tab =>
                            Entity<TabData>(tab).set('sections', sections => sections.map(section =>
                              Entity<SectionData>(section).set('steps', steps => steps.map(step =>
                                step.step.Id == step1.step.Id ? step1 : step)).commit()
                            )).commit()
                          )).commit(),
                          updated_dependencies), state_outer, set_state, should_disable_last_check
                      // appState,
                      // checkboxRadioLabelFilter
                    )}
                  </>)}
                  {formState.form_data.kind == "loaded" &&
                    // formState.form_data.value.latest_submission && 
                    // !formState.form_data.value.latest_submission.submission_finalized && 
                    // !formState.form_data.value.form.is_readonly &&
                    <div className="form__footer">
                      {
                        (() => {

                          let prev_tab: TabData = undefined
                          let prev_sec: SectionData = undefined


                          if (formAppState.tabId && formState.form_data.kind == "loaded") {
                            let sorted_tabs = formState.form_data.value.tabs.sort((a, b) => a.tab.itemOrderNumber - b.tab.itemOrderNumber)
                            let tab_index = sorted_tabs.findIndex(t => t.tab.Id == formAppState.tabId)
                            prev_tab = tab_index > 0 ? sorted_tabs[tab_index - 1] : undefined
                            prev_sec = tab_index > 0 ? sorted_tabs[tab_index - 1].sections[0] : undefined
                          }

                          return <button //code for save and continue
                            onClick={() => {

                              const save_and_continue = (section_reviewed: boolean) => setState(s0 => {
                                let newFormState = Entity<FormState>(formState).set("should_render_deps", _ => true)
                                  .set('form_data', asyncFormData => asyncFormData.kind != 'loaded' ? asyncFormData :
                                    Entity(asyncFormData).set('value', formData =>
                                      Entity(formData).set('tabs', tabs => tabs.map(tab => tab.tab.Id != tabId ? tab :
                                        Entity(tab).set('sections', sections => sections.map(section => section.section.Id != sectionId ? section :
                                          Entity(section).set('section', s =>
                                            Entity(s).set('reviewed', () => section_reviewed)
                                              .commit())
                                            .commit()))
                                          .commit()))
                                        .commit())
                                      .commit())
                                  // .set("form_submission_logic", _ => postFormSubmissionState(data_f.form.Id, formState, school_id))
                                  .commit()

                                return Entity(s0).set("tabId", () => prev_tab.tab.Id)
                                  .set("sectionId", () => prev_sec.section.Id)
                                  .set("formState", _ => Entity(newFormState).set("form_submission_logic", s => {
                                    // console.log("postFormSubmissionState")
                                    return s
                                  }
                                    //postFormSubmissionState(data_f.form.Id, newFormState, school_id)
                                  ).commit())
                                  .commit()
                              })

                              // const stay_and_render_deps = () => setState(s0 =>
                              //   Entity(s0).set("formState", formState =>
                              //     Entity<FormState>(formState).set("should_render_deps", _ => true)
                              //       .commit())
                              //     .commit())

                              // if (generic_dep_output.kind == 'yes' || generic_dep_output.kind == 'not_reviewed') {
                              save_and_continue(true)
                              //   return
                              // }

                              // if (window.confirm(i18next.t("form.confirm.unmet_dependencies"))) {
                              //   save_and_continue(false)
                              //   return
                              // }

                              //   stay_and_render_deps()
                            }}
                            disabled={prev_tab == undefined || prev_sec == undefined}

                            // type="button"
                            className="form__button link"
                          >{i18next.t("form.step_button_text_prev")}</button>

                        })()
                      }
                      <button //code for save and continue
                        onClick={() => {


                          let next_tab: TabData = undefined
                          let next_sec: SectionData = undefined


                          if (formState.form_data.kind == "loaded") {
                            let sorted_tabs = formState.form_data.value.tabs.sort((a, b) => a.tab.itemOrderNumber - b.tab.itemOrderNumber)
                            let tab_index = sorted_tabs.findIndex(t => t.tab.Id == formAppState.tabId)
                            next_tab = tab_index < sorted_tabs.length - 1 ? sorted_tabs[tab_index + 1] : undefined
                            next_sec = tab_index < sorted_tabs.length - 1 ? sorted_tabs[tab_index + 1].sections[0] : undefined
                          }


                          const save_and_continue = (section_reviewed: boolean) => setState(s0 => {
                            let newFormState = Entity<FormState>(formState).set("should_render_deps", _ => true)
                              .set('form_data', asyncFormData => asyncFormData.kind != 'loaded' ? asyncFormData :
                                Entity(asyncFormData).set('value', formData =>
                                  Entity(formData).set('tabs', tabs => tabs.map(tab => tab.tab.Id != tabId ? tab :
                                    Entity(tab).set('sections', sections => sections.map(section => section.section.Id != sectionId ? section :
                                      Entity(section).set('section', s =>
                                        Entity(s).set('reviewed', () => section_reviewed)
                                          .commit())
                                        .commit()))
                                      .commit()))
                                    .commit())
                                  .commit())
                              // .set("form_submission_logic", _ => postFormSubmissionState(data_f.form.Id, formState, school_id))
                              .commit()

                            let s1 = Entity(s0).set("tabId", () => next_tab ? next_tab.tab.Id : -1)
                              .set("sectionId", () => next_sec ? next_sec.section.Id : -1)
                              .set("formState", _ => Entity(newFormState).set("form_submission_logic", s => {
                                // console.log("postFormSubmissionState")
                                if (state_outer && state_outer.upload_form != undefined) {
                                  return state_outer.upload_form(s0)
                                }
                                return s
                              }
                                //postFormSubmissionState(data_f.form.Id, newFormState, school_id)
                              ).commit())
                              .commit()
                            return s1
                          })

                          // const stay_and_render_deps = () => setState(s0 =>
                          //   Entity(s0).set("formState", formState =>
                          //     Entity<FormState>(formState).set("should_render_deps", _ => true)
                          //       .commit())
                          //     .commit())

                          // if (generic_dep_output.kind == 'yes' || generic_dep_output.kind == 'not_reviewed') {
                          save_and_continue(true)
                          //   return
                          // }

                          // if (window.confirm(i18next.t("form.confirm.unmet_dependencies"))) {
                          //   save_and_continue(false)
                          //   return
                          // }

                          //   stay_and_render_deps()
                        }}
                        disabled={((() => {

                          // let x = calculateCompletionRatio(formState.form_data.value, () => List(), formState)
                          // if(!dependencies_boolean_result && formState.form_data.value.tabs.length == formAppState.tabId)
                          //   return true
                          const generic_dep_output = calculateDependenciesOutput(data_f.tabs.filter(tab => tab.tab.Id == tabId)[0].sections.filter(section => section.section.Id == sectionId)[0], formState)
                          return generic_dep_output.kind == "no" || should_disable_last_check
                        })())}

                        // type="button"
                        className="form__button button button--secondary"
                      >{i18next.t("form.step_button_text_next")}</button>
                    </div>}
                </>
                  : <></>
              }
            </Stack>
          </Stack>
        </>
      }
    </Stack>
  })
  // else
  //   return mkWidget({
  //     run: _ => {
  //       let make_readonly_draftjs_text = (field: FieldData) => {
  //         return field.user_input
  //         // get_text_from_draftjs(field.user_input) == "" ? <div style={{ paddingBottom: "5px" }} /> : <Editor
  //         //   readOnly={true}
  //         //   toolbarHidden={true}
  //         //   customStyleMap={{
  //         //     FONT_SIZE_10: {
  //         //       fontSize: "18px"
  //         //     }
  //         //   }}
  //         //   defaultEditorState={(() => {
  //         //     let text = field.user_input ? field.user_input : ""
  //         //     try {
  //         //       let _contentState = convertFromRaw(JSON.parse(field.user_input ? field.user_input : ""))
  //         //       let state = Draft.EditorState.createWithContent(_contentState)
  //         //       return state
  //         //     }
  //         //     catch{
  //         //       let state = Draft.EditorState.createWithContent(Draft.ContentState.createFromText(text))
  //         //       return state
  //         //     }
  //         //   })()} />


  //       }
  //       return <div>
  //         {/* {formState.form_data.kind == "loaded" ? <h1 style={{textAlign:"center", position:"relative", left:"-40px", marginBottom:"20px", paddingBottom:"20px", borderBottom:"3px solid rgb(237, 114, 24)"}}>
  //         {formState.form_data.value.form.title}
  //       </h1>: null} */}
  //         {formState.form_data.kind == "loaded" &&
  //           formState.form_data.value.tabs.sort((a, b) => a.tab.itemOrderNumber - b.tab.itemOrderNumber).filter(tab => tab.tab.title !== "Zoektermen").map((tab, t_key) => <>
  //             <h2 style={{ position: "relative", left: "-40px", paddingLeft: "4px", borderLeft: "3px solid #ED7218" }}>{t_key + 1}:<span />{tab.tab.title}</h2>
  //             {tab.sections.sort((a, b) => a.section.itemOrderNumber - b.section.itemOrderNumber).map((section, s_key) => <>
  //               <h3 style={{ position: "relative", left: "-40px", paddingLeft: "4px", borderLeft: "3px solid #ED7218" }}>{t_key + 1}.{s_key + 1}:<span />{section.section.title}</h3>
  //               {section.steps.filter(step => !stepIsHidden(step, formState)).sort((a, b) => a.step.orderNumber - b.step.orderNumber).map(step => <>
  //                 {step.fields.sort((a, b) => a.field.itemOrderNumber - b.field.itemOrderNumber).filter(x => !x.field.title.startsWith("Vraag 12") && !field_isNull(x)).map(field => {
  //                   let render_field = ((field: FieldData) => <>
  //                     <div>
  //                       {field.field.Kind == "SimpleDate" ? <>
  //                         <label>{field.field.title}</label>
  //                         {field.field.description && <p>{field.field.description}</p>}
  //                         <input
  //                           type="date"
  //                           value={moment(field.user_input, 'YYYY-MM-DD').format('YYYY-MM-DD')}
  //                           readOnly={true}
  //                         />
  //                       </> : field.field.Kind == "CustomReadonlyText" ? <>
  //                         <label>{field.field.title}</label>
  //                         {field.field.description && <p>{field.field.description}</p>}
  //                         <p>{field.user_input}</p>
  //                       </> : field.field.Kind == "Checkbox" ? <>
  //                         <div className="checkbox--container">
  //                           <input
  //                             type="checkbox"
  //                             checked={field.user_input == "true"}
  //                             readOnly={true}
  //                           />
  //                           <label>{field.field.title}</label>
  //                         </div>
  //                       </> : field.field.Kind == "RichText" ? <>
  //                         <label>{field.field.title}</label>
  //                         <p>{field.user_input}</p>
  //                       </> : field.field.Kind == "TextList" ? <>
  //                         <label>{field.field.title}</label>
  //                         <ul>
  //                           {((user_input: string) => {
  //                             let input_array: string[] = user_input ? JSON.parse(user_input) : []
  //                             return input_array;
  //                           })(field.user_input).map(input => <>
  //                             <li>{input}</li>
  //                           </>)}
  //                         </ul>
  //                       </> : field.field.Kind == "Text" ? <>
  //                         <label>{field.field.title}</label>
  //                         {make_readonly_draftjs_text(field)}
  //                       </> : field.field.Kind == "Postcode" ? <>
  //                         <label>{field.field.title}</label>
  //                         <p>{field.user_input}</p>
  //                       </> : field.field.Kind == "Phone" ? <>
  //                         <label>{field.field.title}</label>
  //                         <p>{field.user_input}</p>

  //                       </> : field.field.Kind == "ReadonlyText" ? <>
  //                         <label>{field.field.title}</label>
  //                         {field.field.description} 
  //                         {/* && Components.RichText(false, "view", () => field.field.description, null)} */}
  //                       </> : field.field.Kind == "RadioOption" ? <>
  //                         <label>{field.field.title}</label>
  //                         {field.maybe_answers.map(answer => <>
  //                           <input
  //                             type="radio"
  //                             checked={field.user_input == answer.value || (field.user_input == undefined && answer.isDefaultSelected)}
  //                             readOnly={true}
  //                             name={field.field.Id.toString()}
  //                           />
  //                           <label>{answer.value}</label>
  //                           {field.user_input?.includes(answer.value) ? <>{answer.nested_fields.map(nested => render_field(nested))}</> : <></>}
  //                         </>)}
  //                       </> : field.field.Kind == "Dropdown" ? <>
  //                         <label>{field.field.title}</label>
  //                         <select
  //                           disabled={true}
  //                           value={field.user_input ? field.user_input : field.maybe_answers.find(answer => answer.isDefaultSelected)?.Id}
  //                         >
  //                           {field.maybe_answers.map(answer => <>
  //                             <option value={answer.Id}>{answer.value}</option>
  //                           </>)}
  //                         </select>
  //                       </> : field.field.Kind == "UserEmail" ? <>
  //                         <label>{field.field.title}</label>
  //                         <p>{field.user_input}</p>
  //                       </> : field.field.Kind == "CheckboxMultiSelect" ? <>
  //                         <label>{field.field.title}</label>
  //                         {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map(answer => <>
  //                          <div className="checkbox--container">
  //                             <input
  //                               type="checkbox"
  //                               checked={field.user_input?.includes(answer.value)}
  //                               readOnly={true}
  //                             />
  //                             <label>{answer.value}</label>
  //                           </div>
  //                           {field.user_input?.includes(answer.value) ? <>{answer.nested_fields.map(nested => render_field(nested))}</> : <></>}
  //                         </>)}
  //                       </> : field.field.Kind == "TextArea" ? <>
  //                         <label>{field.field.title}</label>
  //                         {make_readonly_draftjs_text(field)}

  //                       </> : field.field.Kind == "MultiLineText" ? <>
  //                         <label>{field.field.title}</label>
  //                         <p>{field.user_input}</p>
  //                       </> : field.field.Kind == "SimpleNumber" ? <>
  //                         <label>{field.field.title}</label>
  //                         <p>{field.user_input}</p>
  //                       </> : field.field.Kind == "CheckboxGroup" ? <>
  //                         <label>{field.field.title}</label>
  //                         <table>
  //                           <thead>
  //                             <tr>
  //                               <td></td>
  //                               {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map(answer => <td>{answer.value}</td>)}
  //                             </tr>
  //                           </thead>
  //                           <tbody>
  //                             {field.maybe_labels.sort((a1, a2) => a1.Id - a2.Id).map(label => <tr>
  //                               <td>{label.label}</td>
  //                               {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map(answer => 
  //                                 <td>
  //                                   <input
  //                                     type="checkbox"
  //                                     checked={field.user_input && JSON.parse(field.user_input).findIndex((x) => x.id === label.Id && x.values.includes(answer.value)) !== -1}
  //                                     readOnly={true}
  //                                   />
  //                                 </td>
  //                               )}
  //                             </tr>)}
  //                           </tbody>
  //                         </table>
  //                       </> : field.field.Kind == "RadioOptionTable" ? (() => {
  //                         let prev_input = ParseArrayFromString(field.user_input)
  //                         return <>
  //                           <label>{field.field.title}</label>
  //                           <table>
  //                             <thead>
  //                               <tr>
  //                                 <td></td>
  //                                 {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map(answer => <td>{answer.value}</td>)}
  //                               </tr>
  //                             </thead>
  //                             <tbody>
  //                               {field.maybe_labels.sort((a1, a2) => a1.Id - a2.Id).map((label, index) => <tr>
  //                                 <td>{label.label}</td>
  //                                 {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map(answer => 
  //                                   <td>
  //                                     <input
  //                                       type="radio"
  //                                       checked={prev_input[index] ? prev_input[index].substr(prev_input[index].lastIndexOf('-') + 2) == answer.value ? true : false : false}
  //                                       readOnly={true}
  //                                     />
  //                                   </td>
  //                                 )}
  //                               </tr>)}
  //                             </tbody>
  //                           </table>
  //                         </>
  //                       })() : field.field.Kind == "Attachement" ? <>
  //                         <label>{field.field.title}</label>
  //                         <p>{field.user_input}</p>
  //                       </> : field.field.Kind == "TextInputTable" ? (() => {
  //                         let user_input = field.user_input && JSON.parse(field.user_input)
  //                         return <>
  //                           <label>{field.field.title}</label>
  //                           <table>
  //                             <thead>
  //                               <tr>
  //                                 <td></td>
  //                                 {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map(answer => <td>{answer.value}</td>)}
  //                               </tr>
  //                             </thead>
  //                             <tbody>
  //                               {field.maybe_labels.sort((a1, a2) => a1.Id - a2.Id).map((label, label_index) => <tr>
  //                                 <td>{label.label}</td>
  //                                 {field.maybe_answers.sort((a1, a2) => a1.Id - a2.Id).map((answer, answer_index) => 
  //                                   <td>
  //                                     <input
  //                                       type="text"
  //                                       value={user_input && user_input[label_index] && user_input[label_index][1][answer_index] ? user_input[label_index][1][answer_index][1] : ""}
  //                                       readOnly={true}
  //                                     />
  //                                   </td>
  //                                 )}
  //                               </tr>)}
  //                             </tbody>
  //                           </table>
  //                         </>
  //                       })() :

  //                       <p>Field "{field.field.Kind}" could not be rendered</p>
  //                       }
  //                     </div>
  //                   </>)
  //                   return render_field(field)
  //                 })}
  //               </>)}
  //             </>)}
  //           </>)
  //         }
  //       </div>
  //     }
  //   })
}

const setTabIdSectionId: IOWidget<FormData, Action<FormAppState>> = (formData) => {
  const res = (() => {
    for (let i = 0; i < formData.tabs.length; i++) {
      let tab = formData.tabs[i]
      for (let j = 0; j < tab.sections.length; j++) {
        let section = tab.sections[j]
        if (section.steps && section.steps.length > 0) {
          return tuple([tab.tab.Id, section.section.Id])
        }
      }
    }
  })()
  return mkWidget({
    run: setState => <>
      {setState(s => Entity(s).set("tabId", () => res[0]).set("sectionId", () => res[1]).commit())}
    </>
  })
}

// export let school_form_renderer = (data_f: FormData, formState: FormState,
//   update_form_submission_logic: (updated_form_submission_logic: AsyncState<string>) => void,
//   update_form: (updated_form: FormData, updatedDependencyState: DependenciesState) => void,
//   appState: MainMenuState
// ): Widget<Action<FormState>> => {
//   let dependencies_boolean_result = are_all_dependencies_met(formState)
//   let contactDataStep = data_f.tabs[0].sections[0].steps.filter(x => x.step.title.toLowerCase().includes("contactgegevens schoollocatie"))
//   let contactPersonStep = data_f.tabs[0].sections[0].steps.filter(x => x.step.title.toLowerCase().includes("contactpersonen"))
//   return mkWidget({
//     run: setState => (<>
//       {formState.form_submission_logic.kind == 'loading' && status_sending_renderer()}

//       {formState.form_submission_logic.kind == 'connection-error' && formState.form_submission_logic.retryCount >= 10 && status_error_renderer()}
//       {formState.form_submission_logic.kind == 'loaded' &&
//         formState.form_submission_logic.value == 'finalized' &&
//         formState.form_data.kind == 'loaded' ?
//         status_thank_you_renderer(formState.form_data.value.thank_you.content) : <Stack styles={stackStyles} className="block--form">
//           <Stack className="block__inner">
//             <Stack className="block__content" gap={20}>
//               <h2>Algemene informatie</h2>
//               <Stack className="form__group">
//                 <p>Hieronder staan de contactgegevens van uw school. Deze gegevens staan in het adressenbestand van samenwerkingsverband Koers VO. De meeste gegevens zijn zichtbaar in uw schoolprofiel op de website (staat erachter vermeld).</p>
//                 <br></br>
//                 <p>Om ervoor te zorgen dat alle gegevens actueel zijn, vragen we u om deze na te kijken en eventueel aan te passen en op te slaan.</p>
//                 <br></br>
//                 <p>Niet alle gegevens zijn aanpasbaar, verandert er iets of klopt er iets niet? Bel of mail dan naar Lydia Haulussy: 010-4842576, haulussy@koersvo.nl om de gegevens te laten wijzigen.</p>
//               </Stack>
//               <Stack className="form__group">
//                 <h2>Contactgegevens schoollocatie (zichtbaar op website)</h2>
//                 <Stack className="form__group">
//                   <h3 className="form__title">Naam schoollocatie</h3>
//                   <p>{appState.schoolFormData.kind == 'loaded' ? `${appState.schoolFormData.value.School.Name} ${appState.schoolFormData.value.School.Location}` : "-"}</p>
//                 </Stack>
//                 <>
//                   {contactDataStep.map(step =>
//                     step_renderer(step,
//                       formState,
//                       (step1, updated_dependencies) =>
//                         update_form(
//                           Entity<FormData>(data_f).set('tabs', tabs => tabs.map(tab =>
//                             Entity<TabData>(tab).set('sections', sections => sections.map(section =>
//                               Entity<SectionData>(section).set('steps', steps => steps.map(step =>
//                                 step.step.Id == step1.step.Id ? step1 : step)).commit()
//                             )).commit()
//                           )).commit(),
//                         updated_dependencies), appState))}
//                 </>
//               </Stack>
//               <Stack className="form__group">
//               <h2>Contactpersonen</h2>
//                 <Stack className="form__group">
//                   <h3 className="form__title">Directeur</h3>
//                   <p>{appState.director.kind == 'loaded' ? `${appState.director.value.FirstName} ${appState.director.value.Insertion != null ? appState.director.value.Insertion : ""} ${appState.director.value.LastName}, ${appState.director.value.Email}` : "-"}</p>
//                 </Stack>
//                 <>
//                   {contactPersonStep.map(step =>
//                     step_renderer(step,
//                       formState,
//                       (step1, updated_dependencies) =>
//                         update_form(
//                           Entity<FormData>(data_f).set('tabs', tabs => tabs.map(tab =>
//                             Entity<TabData>(tab).set('sections', sections => sections.map(section =>
//                               Entity<SectionData>(section).set('steps', steps => steps.map(step =>
//                                 step.step.Id == step1.step.Id ? step1 : step)).commit()
//                             )).commit()
//                           )).commit(),
//                         updated_dependencies), appState))}
//                 </>
//               </Stack>
//             </Stack>
//           </Stack>

//           <DefaultButton //code for finalising submition
//             onClick={() => 
//               console.log("update_form_submission_logic")
//               //update_form_submission_logic(postSchoolFormSubmissionState(formState, appState.schoolFormData.kind == 'loaded' && appState.schoolFormData.value))
//             }
//             disabled={!dependencies_boolean_result}
//             text={i18next.t("form.submit_button_text")}
//             type="button"
//             className="form__button button button--primary" />
//           {
//             !dependencies_boolean_result ?
//               <div className="alert">
//                 <p className="ms-TextField-errorMessage error-message">
//                   {i18next.t("form.unmet_dependencies_text")}
//                 </p>
//               </div>
//               : null
//           }
//         </Stack>}</>)
//   })
// }


// export let pr_form_renderer = (data_f: FormData, formState: FormState,
//   update_form_submission_logic: (updated_form_submission_logic: AsyncState<string>) => void,
//   update_form: (updated_form: FormData, updatedDependencyState: DependenciesState) => void,
//   appState: MainMenuState
// ): Widget<Action<FormState>> => {
//   let dependencies_boolean_result = are_all_dependencies_met(formState)
//   let steps_to_render = data_f.tabs[0].sections[0].steps
//   if (appState.prEntity.kind == 'loaded') {
//     let prEntity = appState.prEntity.value
//     steps_to_render = steps_to_render.map(step => ({...step,
//       fields: step.fields.map(field => ({...field,
//         user_input: !field.user_input
//         ? field.field.title == 'Logo' 
//           ? prEntity.Logo
//           : field.field.title == 'Fotos'
//           ? prEntity.Photos
//           : field.field.title == 'Twitter' 
//           ? prEntity.Twitter
//           : field.field.title == 'Facebook'
//           ? prEntity.Facebook 
//           : field.field.title == 'Instagram'
//           ? prEntity.Instagram
//           : field.user_input
//         : field.user_input
//       }))
//     }))
//   }
//   return mkWidget({
//     run: setState => (<>
//       {formState.form_submission_logic.kind == 'loading' && status_sending_renderer()}

//       {formState.form_submission_logic.kind == 'connection-error' && formState.form_submission_logic.retryCount >= 10 && status_error_renderer()}
//       { //formState.form_submission_logic.kind == 'loaded' &&
//         //formState.form_submission_logic.value == 'finalized' &&
//         //formState.form_data.kind == 'loaded' ?
//         //status_thank_you_renderer(formState.form_data.value.thank_you.content) : 
//         <Stack styles={stackStyles} className="block--form block--borderless">
//           <Stack className="block__inner">
//             <Stack className="block__content" gap={20}>
//               <h1 className="block__title">PR informatie</h1>
//               <p style={{ marginBottom: "10px" }}>{formState.form_data.kind == "loaded" && formState.form_data.value.form.description}</p>
//               <>{steps_to_render.map(step =>
//                 step_renderer(step,
//                   formState,
//                   (step1, updated_dependencies) =>
//                     update_form(
//                       Entity<FormData>(data_f).set('tabs', tabs => tabs.map(tab =>
//                         Entity<TabData>(tab).set('sections', sections => sections.map(section =>
//                           Entity<SectionData>(section).set('steps', steps => steps.map(step =>
//                             step.step.Id == step1.step.Id ? step1 : step)).commit()
//                         )).commit()
//                       )).commit(),
//                       updated_dependencies), appState))}
//               </>
//               <div className="form__group">
//                 <DefaultButton //code for finalising submition
//                   onClick={() => 
//                     console.log("postPRFormSubmissionState")
//                     //update_form_submission_logic(postPRFormSubmissionState(formState, appState.prEntity.kind == 'loaded' && appState.prEntity.value))
//                   }
//                   disabled={!dependencies_boolean_result}
//                   text={i18next.t("form.submit_button_text")}
//                   type="button"
//                   className="form__button button button--primary" />
//               </div>
//             </Stack>
//           </Stack>
//           {
//             !dependencies_boolean_result ?
//               <div className="alert">
//                 <p className="ms-TextField-errorMessage error-message">
//                   {i18next.t("form.unmet_dependencies_text")}
//                 </p>
//               </div>
//               : null
//           }
//         </Stack>}</>)
//   })
// }



export const createMenus = (formAppState: FormAppState) => {
  let formData = formAppState.formState.form_data.kind == 'loaded' && formAppState.formState.form_data.value
  let tabId = formAppState.tabId
  let sectionId = formAppState.sectionId
  let widgetList: Widget<Action<FormAppState>>[] = formData.tabs.sort((a, b) => a.tab.itemOrderNumber - b.tab.itemOrderNumber).map(tab => mkWidget({
    run: setState => {
      let generic_dep_output: GenericDependencyOutput

      if (tabId == -1) {
        generic_dep_output = undefined
      } else {
        generic_dep_output = calculateDependenciesOutput(tab.sections.filter(section => section.section.Id == sectionId)[0], formAppState.formState)
      }
      return <li className={"block__tab" + (tab.sections && tab.sections.length > 1 ? ' block--subitems' : '')
        + (tabId && tab.tab.Id == tabId ? ' active' : '') + (generic_dep_output && generic_dep_output.kind == 'yes' ? ' completed' : '')}>
        {/* <a className="nav__link" onClick={() => {}
        
        // setState(fad => {

        //   if (!fad.formState.dirty)
        //     return { ...fad, tabId: tab.tab.Id, sectionId: tab.sections && tab.sections.length > 0 ? tab.sections[0].section.Id : null }
        //   // if (window.confirm(i18next.t("form.confirm.unsaved_changes")))
        //   //   return Entity(fad).set('tabId', _ => tab.tab.Id)
        //   //     .set('sectionId', _ => tab.sections && tab.sections.length > 0 ? tab.sections[0].section.Id : null)
        //   //     .set('formState', formState =>
        //   //       Entity(formState).set('should_render_deps', _ => true)
        //   //         .set('form_submission_logic', _ => postFormSubmissionState(formData.form.Id, formState, appState.schoolFormData.kind == 'loaded' && appState.schoolFormData.value.School.Id))
        //   //         .commit())
        //   //     .commit()

        //   // if (window.confirm(i18next.t("form.confirm.discard_changes"))) {
        //   return Entity(fad).set('tabId', _ => tab.tab.Id)
        //     .set('sectionId', _ => tab.sections && tab.sections.length > 0 ? tab.sections[0].section.Id : null)
        //     .set('formState', formState =>
        //       Entity(formState).set('form_data', form_data => form_data.kind == 'loaded' ? { ...form_data, value: addPastSubmissionToUserInput(form_data.value) } : form_data)
        //         .set('should_render_deps', _ => true)
        //         .set('dirty', _ => false)
        //         .commit())
        //     .commit()
        //   // }

        //   // return fad
        // })
        }> */}
        <div className="block__circle">
          <svg className="block__checkmark" height="10" viewBox="0 0 13 10" width="13" xmlns="http://www.w3.org/2000/svg">
            <path d="m112.270463 50.3160589c.37773-.4029123 1.010566-.4233264 1.413478-.0455961.371919.3486741.417923.9147162.125704 1.3166379l-.080108.0968404-7.5 8c-.356651.3804281-.938624.4186337-1.340234.108075l-.09641-.0849093-3-3c-.390524-.3905243-.390524-1.0236893 0-1.4142136.360484-.3604839.927715-.3882135 1.320006-.0831886l.094208.0831886 2.269893 2.2691068z" fill="#067bca" transform="translate(-101 -50)" />
          </svg>
        </div>
        <span>{tab.tab.title}</span>
        {/* </a> */}
        {/* {tab.sections && tab.sections.length > 0 &&
          <ul className="nav__sublist sublist">
            {tab.sections.length <= 1 ? null : tab.sections.sort((a, b) => a.section.itemOrderNumber - b.section.itemOrderNumber).map(section =>
              <li className={"sublist__item" + (section.section.reviewed ? ' sublist__item--complete' : '') + (sectionId && section.section.Id == sectionId ? ' sublist__item--active' : '')}>
                <a className="sublist__link" onClick={() => setState(fad => {
                  if (!fad.formState.dirty)
                    return { ...fad, tabId: tab.tab.Id, sectionId: section.section.Id }
                  // if (window.confirm(i18next.t("form.confirm.unsaved_changes")))
                  //   return Entity(fad).set('tabId', _ => tab.tab.Id)
                  //     .set('sectionId', _ => section.section.Id)
                  //     .set('formState', formState =>
                  //       Entity(formState).set('should_render_deps', _ => true)
                  //         .set('form_submission_logic', _ => postFormSubmissionState(formData.form.Id, formState, appState.schoolFormData.kind == 'loaded' && appState.schoolFormData.value.School.Id))
                  //         .commit())
                  //     .commit()

                  // if (window.confirm(i18next.t("form.confirm.discard_changes"))) {
                  return Entity(fad).set('tabId', _ => tab.tab.Id)
                    .set('sectionId', _ => section.section.Id)
                    .set('formState', formState =>
                      Entity(formState).set('form_data', form_data => form_data.kind == 'loaded' ? { ...form_data, value: addPastSubmissionToUserInput(form_data.value) } : form_data)
                        .set('should_render_deps', _ => true)
                        .set('dirty', _ => false)
                        .commit())
                    .commit()
                  // }

                  // return fad
                })}>
                  {section.section.title}
                </a>
              </li>)}
          </ul>} */}
      </li>
    }
  }))
  widgetList = widgetList.concat(
    //   [mkWidget({
    //   run: setState =>
    //     <li className={"nav__item " + (tabId && tabId == -1 ? ' nav__item--active' : '')}>
    //       <a className="nav__link" onClick={() => setState(fas => { return { ...fas, tabId: -1, sectionId: null } })}>
    //         {i18next.t("form.submit_tab.title")}
    //       </a>
    //     </li>
    // })]
  )
  return any<Action<FormAppState>>()(widgetList)
}
